var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { class: this.sidemenu_minimized, attrs: { id: "sidebar" } },
    [
      _c("div", { staticClass: "sidebar-header" }, [
        _c(
          "div",
          {
            staticStyle: { "margin-top": "65px", "margin-left": "5px" },
            on: {
              click: function($event) {
                return _vm.toggleToIcons()
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-bars fa-1x" }),
            _vm._v(" "),
            _c("span", { staticClass: "menu-item-name app-heading" }, [
              _vm._v("Mentoring")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled" }, [
        _c(
          "li",
          { staticClass: "active" },
          [
            _c("router-link", { attrs: { to: "/researcher-dashboard" } }, [
              _c("i", { staticClass: "fa fa-home" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [_vm._v("Home")])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                class: [
                  _vm.currentPage.includes(
                    "account-lookup",
                    "account-lookup/view-list"
                  )
                    ? _vm.activeClass
                    : ""
                ],
                attrs: { to: "/account-lookup" }
              },
              [
                _c("i", { staticClass: "fa fa-user-o" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item-name" }, [
                  _vm._v("Account Lookup")
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "heading-seperator" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-unstyled" },
        [
          _c(
            "li",
            { staticClass: "active" },
            [
              _c(
                "b-link",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: "collapse-report-submenu",
                      expression: "'collapse-report-submenu'"
                    }
                  ]
                },
                [
                  _c("i", { staticClass: "fa fa-line-chart" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Reports\n         "),
                    _c("i", {
                      staticClass: "fa fa-angle-down report-dropdown",
                      staticStyle: { "font-size": "20px" }
                    })
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-collapse", { attrs: { id: "collapse-report-submenu" } }, [
            _c("ul", { staticClass: "nav flex-column ml-3" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/account-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Account Report")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/account-contact-report" } },
                    [
                      _c("i", { staticClass: "fa fa-user-o" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Account Contact Report")
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled list-signout-menu" }, [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/logout" } }, [
              _c("i", { staticClass: "fa fa-sign-out" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Sign Out")
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eeccac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eeccac2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/researcher_sidebar_menu.vue
// module id = null
// module chunks = 